import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { id: "questionsTable" }
const _hoisted_2 = { id: "question_text" }
const _hoisted_3 = {
  key: 0,
  class: "attention"
}
const _hoisted_4 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_5 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_6 = {
  key: 2,
  class: "contents-question-answer-radio"
}
const _hoisted_7 = ["onUpdate:modelValue", "value"]
const _hoisted_8 = {
  key: 3,
  class: "contents-question-answer-checkbox"
}
const _hoisted_9 = ["value", "onUpdate:modelValue"]
const _hoisted_10 = { key: 4 }
const _hoisted_11 = { class: "custom-button" }
const _hoisted_12 = ["onChange"]
const _hoisted_13 = ["onDrop"]
const _hoisted_14 = { class: "image-input-text" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 5,
  class: "error-text"
}


import { fromBuffer } from "file-type";
import { Question } from "@/models/healthCare/types/question";
import { _$t } from "@/utils/i18n";

// ---- Variable ----------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionTable',
  props: {
    questions: {}
  },
  setup(__props: any) {



// ---- Methods ----------------------------------------------
//添付ファイル処理
const attachFile = async (event: any, question: any) => {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (!file) return;

  const arrayBufferReader = new FileReader();
  arrayBufferReader.onload = async (e) => {
    question.error = "";
    const buffer = e.target?.result as ArrayBuffer;
    const fileType = await fromBuffer(new Uint8Array(buffer));
    const allowedFormats = ["image/png", "image/jpeg", "image/gif"];
    if (!fileType || !allowedFormats.includes(fileType.mime)) {
      question.error = _$t("survey_msg_allowed_file_type");
      return;
    }

    // タイプチェックOKならDataURLで読み込んでCanvasで処理
    const dataUrlReader = new FileReader();
    dataUrlReader.onload = (e2) => {
      const dataUrl = e2.target?.result as string;
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        question.answer = canvas.toDataURL("image/png");
        question.preview = question.answer;
        question.fileName = file.name;
        question.fileType = file.type;
      };

      img.src = dataUrl;
    };
    dataUrlReader.readAsDataURL(file);
  };

  // バイナリでチェック
  arrayBufferReader.readAsArrayBuffer(file);
};

//ドラッグオーバー処理
const handleDragOver = (event: DragEvent) => {
  event.preventDefault();
};

//ドロップ処理
const handleDrop = (event: DragEvent, question: any) => {
  event.preventDefault();
  // get file
  const file = event.dataTransfer?.files[0];
  attachFile({ target: { files: [file] } }, question);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question) => {
      return (_openBlock(), _createElementBlock("tr", {
        class: "contents-question-title",
        key: question.question_code
      }, [
        _createElementVNode("th", _hoisted_2, [
          _createTextVNode(_toDisplayString(question.question_text) + " ", 1),
          (question.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "※"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", null, [
          (question.answer_format === 0)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                "onUpdate:modelValue": ($event: any) => ((question.answer) = $event),
                type: "text",
                placeholder: _ctx.$t('survey_text_placeholder')
              }, null, 8, _hoisted_4)), [
                [_vModelText, question.answer]
              ])
            : _createCommentVNode("", true),
          (question.answer_format === 1)
            ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                key: 1,
                class: "question-answer-text",
                "onUpdate:modelValue": ($event: any) => ((question.answer) = $event),
                placeholder: _ctx.$t('survey_text_placeholder')
              }, null, 8, _hoisted_5)), [
                [_vModelText, question.answer]
              ])
            : _createCommentVNode("", true),
          (question.answer_format === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.choices, (choice) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: choice.choice_code
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      "onUpdate:modelValue": ($event: any) => ((question.answer) = $event),
                      value: choice.choice_code
                    }, null, 8, _hoisted_7), [
                      [_vModelRadio, question.answer]
                    ]),
                    _createElementVNode("span", null, _toDisplayString(choice.choice_text), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (question.answer_format === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.choices, (choice) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: choice.choice_code
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      value: choice.choice_code,
                      "onUpdate:modelValue": ($event: any) => ((question.answer) = $event)
                    }, null, 8, _hoisted_9), [
                      [_vModelCheckbox, question.answer]
                    ]),
                    _createElementVNode("span", null, _toDisplayString(choice.choice_text), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (question.answer_format === 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, [
                  _createTextVNode(_toDisplayString(_ctx.$t("survey_button_select_file")) + " ", 1),
                  _createElementVNode("input", {
                    type: "file",
                    accept: "image/png, image/jpeg, image/gif",
                    onChange: ($event: any) => (attachFile($event, question)),
                    style: {"display":"none"}
                  }, null, 40, _hoisted_12)
                ]),
                _createElementVNode("div", {
                  class: "image-input-area",
                  onDragover: _withModifiers(handleDragOver, ["prevent"]),
                  onDrop: _withModifiers(($event: any) => (handleDrop($event, question)), ["prevent"])
                }, _toDisplayString(_ctx.$t("survey_msg_able_to_drag-and-drop")), 41, _hoisted_13),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("survey_msg_allowed_file_type")), 1),
                (question.preview)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: question.preview,
                      alt: "Preview",
                      class: "image-preview"
                    }, null, 8, _hoisted_15))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (question.error)
            ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(question.error), 1))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
}
}

})